import { render } from "./ProjectAnalysisTextMainSentiment.vue?vue&type=template&id=2ec8025b"
import script from "./ProjectAnalysisTextMainSentiment.vue?vue&type=script&lang=js"
export * from "./ProjectAnalysisTextMainSentiment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__